import Button from "@pathwright/ui/src/components/button/Button"
import SubmitButton from "@pathwright/ui/src/components/button/SubmitButton"
import { ConnectForm, TextInput } from "lib/core/components/forms"
import "./PathTopicForm.css"

let fieldsData = {
  name: {
    label: "Title",
    placeholder: "Enter divider title",
    autoFocus: true,
    hideLabel: true,
    hideStatus: true,
    inverted: true,
    minimal: true,
    inline: true
  }
}

let PathTopicForm = function (props) {
  let actionLabel, handleSubmit, isValid, onCancel
  ;({ fieldsData, handleSubmit, actionLabel, onCancel, isValid } = props)

  return (
    <form
      onSubmit={handleSubmit}
      className="PathTopic__Form"
      autoComplete="off"
    >
      <TextInput {...Object.assign({}, fieldsData.name)} />
      <div className="PathTopic__FormControls">
        <Button onClick={onCancel} styleType="blank" inverted={true}>{`\
Cancel\
`}</Button>
        <SubmitButton
          {...Object.assign({}, props, {
            styleType: "primary",
            type: "submit",
            inverted: true
          })}
        >
          {actionLabel}
        </SubmitButton>
      </div>
    </form>
  )
}

PathTopicForm = ConnectForm(PathTopicForm, fieldsData)
PathTopicForm.displayName = "PathTopicForm"

export default PathTopicForm
